<template>
    <el-row>
        <el-col>
            <el-table :data="useRecordData" style="width: 100%" :default-sort="{ prop: 'date', order: 'descending' }">
                <el-table-column type="index" label="序号">
                </el-table-column>
                <el-table-column prop="laboratory" label="试验室" sortable width="200">
                </el-table-column>
                <el-table-column prop="sampleName" label="样品名称" sortable>
                </el-table-column>
                <el-table-column prop="sampleNumber" label="样品编号" sortable>
                </el-table-column>
                <el-table-column prop="startDate" label="起始时间" sortable>
                </el-table-column>
                <el-table-column prop="endDate" label="结束时间" sortable>
                </el-table-column>
                <el-table-column prop="beforeStatue" label="使用前状态" sortable>
                </el-table-column>
                <el-table-column prop="afterStatue" label="使用后状态" sortable>
                </el-table-column>
                <el-table-column prop="userName" label="使用人" sortable>
                </el-table-column>
            </el-table>
        </el-col>

        <!--分页工具条-->
        <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
            <el-pagination v-if="useRecordData.length > 0" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :page-sizes="[5]" :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right">
            </el-pagination>
        </el-col>
    </el-row>
</template>
<script>
export default {
    data() {
        return {
            pagesize:5,
            total:4,
            useRecordData: [
            //   {
            //     laboratory: '桑园子大桥工地试验室',
            //     sampleName: '水泥',
            //     sampleNumber: 'YP-01-012',
            //     startDate: '2022-10-18',
            //     endDate: '2022-10-18',
            //     beforeStatue: '正常',
            //     afterStatue: '正常',
            //     userName: '王培鑫',
            // }, {
            //     laboratory: '桑园子大桥工地试验室',
            //     sampleName: '水泥',
            //     sampleNumber: 'YP-01-008',
            //     startDate: '2022-05-18',
            //     endDate: '2022-05-26',
            //     beforeStatue: '正常',
            //     afterStatue: '正常',
            //     userName: '王培鑫',
            // }, {
            //     laboratory: '清傅试验室',
            //     sampleName: '水泥',
            //     sampleNumber: 'YP-01-007',
            //     startDate: '2022-02-22',
            //     endDate: '2022-03-12',
            //     beforeStatue: '正常',
            //     afterStatue: '正常',
            //     userName: '高小炬',
            // }, {
            //     laboratory: '清傅试验室',
            //     sampleName: '水泥',
            //     sampleNumber: 'YP-01-003',
            //     startDate: '2022-09-19',
            //     endDate: '2022-09-19',
            //     beforeStatue: '正常',
            //     afterStatue: '正常',
            //     userName: '高小炬',
            // }
        ]
        }
    },
    props: {
        deviceinfo: {
            default: {}
        }
    },
    methods: {
        handleCurrentChange(val) {
        //     this.pageIndex = val;
        //     //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
        //     //.slice()方法接受两个参数，开始和结束的值
        //     //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
        //    this.getDeviceinfo();
        },
        handleSizeChange(val) {
        //     this.pagesize = val;
        //    this.getDeviceinfo();
        },
    },
    created() {

    }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/views/device/components/DeviceUseRecord.vue